import React from 'react'

function HomeBox4() {
    return (
        <div className='home-box4main' id='home-box4'>
            <div className='container'>
                <div className='home-box4'>
                    <div className='home-box4-top'>
                        <h2>Help customers discover and join your loyalty program faster</h2>
                        <p>Promote your rewards program across the channels your audience already uses every day.</p>
                    </div>
                    <div className='home-box4-bottom'>
                        <div className='home-box4-bottom-box'>
                            <h5>Reach Customers Everywhere</h5>
                            <p>Share your loyalty program across every customer touchpoint. Add your QR code to menus, packaging, receipts, social media, and your website so customers can join and earn rewards wherever they interact with your business.</p>
                            <img src="/tent-card-promotion.png" alt="box4-img" />
                        </div>
                        <div className='home-box4-bottom-box'>
                            <img src="/loopy-loyalty-stamper-app.png" alt="box4-img" id='box4-bottom-box-img' />
                            <h5>Designed for Modern Businesses</h5>
                            <p>Manage your loyalty program effortlessly with a simple and intuitive platform. Create rewards, track customer engagement, and grow repeat business without adding complexity to your daily operations.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HomeBox4